import React from 'react';

export default (props) => (
    <div className="view-header">
        <div className="kr-user-header">
            {props.isTour && <button onClick={() => props.openTour()} className="start_tour_btn btn btn-primary">Start Tour</button>}
            <button disabled={props.disabled} onClick={() => props.openSubCaseModal()} className={`btn btn-secondary ${props.isTour ? 'subcase_tour' : ''}`}>Create Subcase</button>
            {props.showSaveButton && (
                <div>
                    <button
                        className="btn no-shadow-btn btn-save btn-primary"
                        disabled={props.saveDisabled}
                        onClick={props.handleSave}>
                        {'Save'}
                    </button>
                </div>
            )}
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/view-header.js